module.exports = __webpack_public_path__ + "761d9208cf06bf32bc1470f2db174382.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/sweater.png
// module id = 2010
// module chunks = 0